<div
  class="menu-item"
  [class]="{ 'root-level': isRootLevel(),
    'selected': isSelected()
   }">
  @switch (icon() ? 'iconTemplate' : 'shortNameTemplate') {
    @case ('iconTemplate') {
      <app-icon [icon]="icon()" [size]="isRootLevel() ? 'md' : 'sm'" />
    }
    @case ('shortNameTemplate') {
      <span class="menu-icon">{{ shortLabel() }}</span>
    }
  }
  @if (isWide()) {
    <span class="menu-item-name">{{ label() }}</span>
  }
</div>
